import {Navigate, useLocation, useSearchParams} from 'react-router-dom';

/**
 * Legacy URL after program registration. Redirects to `/registration/:referenceCode`
 * so status and payment link are always loaded fresh from the API.
 */
export default function CampRegisterSuccess() {
    const location = useLocation();
    const [searchParams] = useSearchParams();

    const refFromQuery = (searchParams.get('ref') || '').trim();
    const refFromState = (location.state?.kkrnValue || '').trim();
    const ref = refFromQuery || refFromState;

    if (ref && ref !== '---') {
        return (
            <Navigate
                to={`/registration/${encodeURIComponent(ref)}`}
                replace
                state={{fromRegistrationSubmit: true}}
            />
        );
    }

    return (
        <div className="container py-5 text-center">
            <h2 className="fw-bold mb-3">Kayıt özeti</h2>
            <p className="text-muted">
                Referans kodu bulunamadı. Lütfen onay e-postanızdaki bağlantıyı kullanın veya aşağıdaki formattan
                deneyin:
            </p>
            <p className="small text-break">
                <code>/registration/SİZİN_REFERANS_KODUNUZ</code>
            </p>
        </div>
    );
}
